import styled from 'styled-components';

const defaultComponent = styled.input`
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: space-between;
  align-items: center;
  width: auto;
  font-size: 1rem;
  color: #606060;
  font-family: Arial;
  margin: 0.125rem 0 2rem 0;
  padding: 0.125rem;
  height: auto;
  border: 0;
  border-bottom: 0.125rem solid #808080;
  border-radius: 0.25rem;
  mask-type: ${(props) => props.type};

  &:focus {
    outline: 0;
  }
`;

const Input = {
  Default: defaultComponent,
};

export default Input;
